


























































import Vue from 'vue';
import store from '@/store';

export default Vue.extend({
    name: 'Login',

    beforeRouteEnter(to, from, next) {
        if (store.getters.isLoggedIn) {
            return next('/');
        }

        next();
    },

    data() {
        return {
            loading: false,
            email: '',
            password: '',
            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'error',
        };
    },

    methods: {
        async submit() {
            this.loading = true;

            const { email, password } = this;

            try {
                await this.$store.dispatch('login', {
                    email,
                    password,
                });


                const redirect: string = (this.$route.query.redirect as string) || '/';
                await this.$router.replace(redirect);
            } catch (error) {
                error && error.message && this.showSnackbarMessage(error.message);
            }

            this.loading = false;
        },
        showSnackbarMessage(message: string) {
            this.snackbarMessage = message;
            this.snackbar = true;
        },
    },
});
